import { makeStyles, Typography } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createTheme';
import { useIsAspenHostedDealer, useIsIdealHostedDealer, useIsInfinityHostedDealer } from 'common/hooks';
import moment from 'moment';
import React from 'react';

const useStyles = makeStyles((theme: Theme): any => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    color: theme.palette.grey[900],
    fontSize: '9px',
    lineHeight: 1.4,
    '&&.left': {
      marginLeft: theme.spacing(1),
      justifyContent: 'flex-start',
      textAlign: 'left',
    },
    '&&.right': {
      marginRight: theme.spacing(2),
      justifyContent: 'flex-end',
      textAlign: 'right',
    },
  },
  userName: {
    marginLeft: theme.spacing(0.5),
  },
}));

function Footer({
  status,
  dateTime,
  userName,
  direction,
}: {
  status: string;
  dateTime: string;
  userName: string;
  direction: string;
}): React.ReactElement {
  const classes: any = useStyles();
  const isIdealHostedDealer = useIsIdealHostedDealer();
  const isAspenHostedDealer = useIsAspenHostedDealer();
  const isInfinityHostedDealer = useIsInfinityHostedDealer();
  const isHostedDmsDealer = isIdealHostedDealer || isAspenHostedDealer || isInfinityHostedDealer;
  const offset = isHostedDmsDealer ? sessionStorage.getItem('dealerGmtOffset') : null;
  const formattedDateTime = (offset ? moment.utc(dateTime).utcOffset(offset) : moment.utc(dateTime).local()).format('M-D h:mm a');
  return (
    <Typography className={`${classes.root} ${direction}`} component="div" variant="caption">
      <span>{status} - {formattedDateTime}</span>
      {userName && <span className={classes.userName}>{userName}</span>}
    </Typography>
  );
}

export default Footer;
